import { render, staticRenderFns } from "./FactorToggleGroup.vue?vue&type=template&id=05d15a8a&"
import script from "./FactorToggleGroup.vue?vue&type=script&lang=ts&"
export * from "./FactorToggleGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports